import { render } from "./ReportsChartSection.vue?vue&type=template&id=90fcb68a&scoped=true"
import script from "./ReportsChartSection.vue?vue&type=script&lang=js"
export * from "./ReportsChartSection.vue?vue&type=script&lang=js"

import "./ReportsChartSection.vue?vue&type=style&index=0&id=90fcb68a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fcb68a"]])

export default __exports__